<template>
  <ui-dialog
    :isVisible="isVisible"
    :isLoading="isLoading"
    :title="L10n('duplicate-stock')"
    @close="handleCancel"
  >
    <edit-form
      ref="form"
      :data="dataForm"
      @change="handleChange"
      :model="modelDataForm"
    />
    <template v-slot:footer>
      <div class="d-flex">
        <el-checkbox v-model="isShowAfterCreate">
          {{L10n('go-to-duplicate')}}
        </el-checkbox>
        <button class="btn btn-border grey btn-size-s btn-mobile-full" style="margin-left: auto" @click="handleCancel">
          {{L10n('close')}}
        </button>
        <button class="ml-sm-3 btn btn-size-s btn-mobile-full" @click="handleDuplicate">
          {{L10n('duplicate')}}
        </button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>
import { ServiceStocks } from '@/services/Stocks'

export default {
  name: 'StockDuplicate',
  components: {
    'ui-dialog': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/Dialog'),
    'edit-form': () => import(/* webpackChunkName: 'Stocks' */ './Form')
  },
  props: {
    isVisible: { type: Boolean },
    stockID: { required: true }
  },
  data () {
    return {
      isShowAfterCreate: true,
      isLoading: false,
      dataForm: {}
    }
  },
  watch: {
    isVisible: {
      handler (v) {
        if (v) {
          this.open()
        }
      }
    }
  },
  methods: {
    modelDataForm () {
      return {
        partSN: ''
      }
    },
    handleChange (data) {
      this.dataForm = { ...data }
    },
    async open () {
      this.dataForm = {}
    },
    handleCancel () {
      this.$emit('update:isVisible', false)
    },
    async requestDuplicate () {
      this.isLoading = true
      try {
        const { data: dataStock } = await ServiceStocks.get(this.stockID)
        const data = {
          ...dataStock,
          ...this.dataForm
        }
        const { data: createdEntity } = await ServiceStocks.createDuplicate({ originStockID: this.stockID, data })
        this.requestSuccessHandler()

        this.$emit('onDuplicateSuccess', {
          data: createdEntity,
          isShowAfterCreate: this.isShowAfterCreate
        })
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
        this.$emit('update:isVisible', false)
      }
    },
    async handleDuplicate () {
      try {
        await this.$refs['form'].validate()
        await this.requestDuplicate()
      } catch (e) {
        this.validateErrorHandler()
      }
    }
  }
}
</script>
